import { render, staticRenderFns } from "./MoleculeContentBlockIframe.vue?vue&type=template&id=120458d5&"
import script from "./MoleculeContentBlockIframe.vue?vue&type=script&lang=js&"
export * from "./MoleculeContentBlockIframe.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeContentBlockIframe.vue?vue&type=style&index=0&id=120458d5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports